module.exports = __webpack_public_path__ + "static/media/permission-add.bba07479.svg";